import React from 'react';
import './FAQ.css';

function FAQ() {
  const faqs = [
    {
      question: "Quanto costa una lezione?",
      answer: "Il costo di una singola lezione è di 25 CHF. In ogni caso, è possibile previo accordo beneficiare di sconti acquistando in anticipo pacchetti di lezioni."
    },
    {
      question: "Dove si svolgono le lezioni?",
      answer: "Le lezioni si svolgono su un'apposita stanza all'interno dell'app Zoom. Alternativamente, si possono concordare lezioni in presenza nell'area di Lugano."
    },
    {
      question: "Che argomenti coprono le lezioni?",
      answer: "Le lezioni coprono qualsiasi argomento inerente l'italiano. Dalla scrittura creativa all'analisi logica, grammaticale e del periodo, passando per la letteratura."
    },
    {
      question: "È possibile fare una lezione di prova?",
      answer: "Assolutamente sì, tramite il link qui sotto ci si può mettere in contatto per organizzare una lezione di prova gratuita di un'ora."
    }
  ];

  return (
    <section className="faq">
      <h2>FAQ - Domande frequenti</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
